/**
 * @generated SignedSource<<936b021705a988b95f5c0a0faf025cbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelatedPhotosGrid_photos$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"RelatedPhotosGridTile_photo">;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "RelatedPhotosGrid_photos";
};
export type RelatedPhotosGrid_photos$key = {
  readonly " $data"?: RelatedPhotosGrid_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedPhotosGrid_photos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelatedPhotosGrid_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RelatedPhotosGridTile_photo"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};

(node as any).hash = "be0d0ea528f8f220ebc9c18398503d87";

export default node;
